/**
 * WordPress dependencies
 */
import { Fragment } from '@wordpress/element';
import { addFilter } from '@wordpress/hooks';
import { Toolbar, Button } from '@wordpress/components';
import { __ } from '@wordpress/i18n';

/**
 * Inner dependencies.
 */
import blockInfo from '../constants';
const { hookPrefix } = blockInfo;

const EditButton = ( props ) => {
	const { toggleEditSlidesMode, isEditing } = props;
	return <Toolbar>
		<Button isPressed={ isEditing } icon="edit" showTooltip={ true } label={ __( 'Edit' ) } className={ 'components-toolbar-button' } onClick={ () => {
			toggleEditSlidesMode();
		} } />
	</Toolbar>;
};

addFilter(
	`gutenify-block-${ hookPrefix }-block-controls`,
	`Gutenify/Block/${ hookPrefix }/InspectorControls/BlockControls/edit-slides`,
	( content, props ) => {
		return [
			...content,
			<Fragment key={ `gutenify-block-${ hookPrefix }-options-block-control-edit-slides` }>
				<EditButton { ...props } />
			</Fragment>,
		];
	}
);
